<template>
  <div>
    <page-heading title="Logout"></page-heading>
    <el-card>
        Se ya later....
    </el-card>
  </div>
</template>

<script>
  export default {
    name: 'Logout',
    data() {
      return {
        translationPrefix: 'pages.logout',
      };
    },
  };
</script>
<style lang="scss" scoped>
  .el-card{
    min-height: 300px;
  }
</style>


// WEBPACK FOOTER //
// src/pages/Logout.vue